
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { BASE_URL } from '@/common/constant';
import { $delay } from '@/common/utils';
import { component as Viewer } from 'v-viewer';
import lazyInject from '@/di';
import { FormModel } from 'ant-design-vue';
import moment, { Moment } from 'moment';
import VoucherService from '@/services/voucher.service';
import CarService from '@/services/car.service';

@Component({
  components: {
    Viewer,
  },
})
export default class EditVoucherModal extends Vue {
  visible = false;

  uploading = false;

  type = '';

  title = '编辑收款凭证';

  voucher: any = '';

  rules: any = {
    headlineImage: [
      { required: true, message: '请上传支付凭证', trigger: 'change' },
    ],
    channel: [
      { required: true, message: '请选择支付渠道', trigger: 'change' },
    ],
    amount: [
      { required: true, message: '请输入收款凭证金额', trigger: 'change' },
    ],
    payee: [
      { required: true, message: '请输入付款方', trigger: 'change' },
    ],
    flow_no: [
      { required: true, message: '请输入收款流水号', trigger: 'change' },
    ],
    receive_time: [
      { required: true, message: '请输入收款时间', trigger: 'change' },
    ],
  };

  fileList: any = [];

  BASE_URL = BASE_URL;

  labelCol = {
    span: 6,
  };

  wrapperCol = {
    span: 12,
  };

  form: any = {
    paymentChannelId: undefined,
    flow_no: '',
    channel: '',
    resource_id: '',
    receive_time: '',
    amount: '',
    headlineImage: '',
    payee: '',
  };

  token: string | undefined = undefined;

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  @lazyInject(UserService)
  protected userService!: UserService;

  @Ref('ruleForm')
  private ruleForm!: FormModel;

  @lazyInject(VoucherService)
  voucherService!: VoucherService;

  @lazyInject(CarService)
  carService!: CarService;

  @Prop()
  paymentChannel?: any;

  handleOk() {
    this.ruleForm.validate(async (valid) => {
      if (valid) {
        const data = {
          flowNo: this.form.flow_no,
          channel: this.form.channel,
          resourceId: this.fileList[0].id || '',
          receivePaymentTime: moment(this.form.receive_time).format('YYYY-MM-DD HH:mm:ss'),
          amount: this.form.amount,
          payee: this.form.payee,
          labelId: 1,
          receiptVoucherId: this.voucher.id,
        };
        console.log(data);
        const res = await this.carService.postShopOrderVoucher(data);
        if (res) {
          this.$message.success('修改成功');
          this.$emit('queryChange', this.form.flow_no);
          this.$emit('search');
          this.visible = false;
        }
      } else {
        return false;
      }
    });
  }

  handleCancel() {
    this.visible = false;
    this.form = {
      paymentChannelId: undefined,
      flow_no: '',
      channel: '',
      resource_id: '',
      receive_time: '',
      amount: '',
      headlineImage: '',
      payee: '',
    };
    this.ruleForm.resetFields();
  }

  async init(type: string, record?: any) {
    this.type = type;
    this.title = type === 'look' ? '查看收款凭证' : '编辑收款凭证';
    this.voucher = record;
    const res = await this.voucherService.getDyhOrderVoucherDetail({
      flow_no: record.flow_no,
      channel: record.channel,
    });
    this.form = res;
    const imgArr = [{ id: res.resource_id, url: res.resource_img }];
    this.fileList = imgArr;
    this.form.headlineImage = imgArr;
    this.visible = true;
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  onChangePaymentTime(value: Moment) {
    this.$set(this.form, 'receive_time', value);
  }

  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }
  _v = 1;
  async onRemove(v: any) {
    // console.log(v);
    this._v = v;
  }

  delShopImg(index: number) {
    // if (this.fileList.length < 4) {
    //   this.$message.error('店铺相册图片不能小于3张');
    // } else {
    const idList = this.fileList.map((item: any) => item.id);
    idList.splice(index, 1);
    this.fileList.splice(index, 1);
    // }
  }

  async onChangeImg(info: any) {
    // console.log(info);
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const headlineImage = {
        id: data[0]?.id,
        uid: data[0]?.id,
        url: data[0]?.url,
        name: 'mage.png',
        status: 'done',
      };
      this.fileList.push(headlineImage);
      this.$set(this.form, 'headlineImage', headlineImage);
      this.uploading = false;
    }
    if (info.file.status === 'removed') {
      if (info.file.xhr) {
        const { data } = JSON.parse(info.file.xhr.response);
        const id = data[0]?.id;
        this.fileList = this.fileList.filter((res: { id: any }) => { return res.id !== id; });
      } else {
        // console.log(info.file);
        const { id } = info.file;
        this.fileList = this.fileList.filter((res: { id: any }) => { return res.id !== id; });
      }
    }
  }
}
